"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGridVariables = void 0;
var _utils = require("../../utils");
var _constants = require("./constants");
const getGridVariables = mediaQueries => ({
  variable: _constants.GRID_SPACING_CSS_VARIABLE_NAME,
  value: (0, _utils.px)(_constants.GRID_SPACING.xl),
  mediaQueries: {
    ...mediaQueries.lg({
      ':root': {
        [_constants.GRID_SPACING_CSS_VARIABLE_NAME]: (0, _utils.px)(_constants.GRID_SPACING.lg)
      }
    }),
    ...mediaQueries.md({
      ':root': {
        [_constants.GRID_SPACING_CSS_VARIABLE_NAME]: (0, _utils.px)(_constants.GRID_SPACING.md)
      }
    }),
    ...mediaQueries.sm({
      ':root': {
        [_constants.GRID_SPACING_CSS_VARIABLE_NAME]: (0, _utils.px)(_constants.GRID_SPACING.sm)
      }
    })
  }
});
exports.getGridVariables = getGridVariables;